const HISTORY_LIMIT = 100;

export const initialScheduleHistory = {
  redoStack: [],
  undoStack: [],
};

const createSnapshot = (state) => ({
  cloList: state.cloList,
  routeErrors: state.routeErrors,
  currentRoute: state.currentRoute,
  currentRouteItems: state.currentRouteItems,
  currentRouteContainers: state.currentRouteContainers,
});

const snapshotsMatch = (left, right) => (
  left && right
  && left.cloList === right.cloList
  && left.routeErrors === right.routeErrors
  && left.currentRoute === right.currentRoute
  && left.currentRouteItems === right.currentRouteItems
  && left.currentRouteContainers === right.currentRouteContainers
);

const restoreSnapshot = (state, snapshot) => ({
  ...state,
  ...snapshot,
});

export const captureScheduleSnapshot = (state) => {
  const snapshot = createSnapshot(state);
  const { undoStack } = state.scheduleEditorHistory;

  if (snapshotsMatch(undoStack[undoStack.length - 1], snapshot)) return state;

  return {
    ...state,
    scheduleEditorHistory: {
      redoStack: [],
      undoStack: [...undoStack, snapshot].slice(-HISTORY_LIMIT),
    },
  };
};

export const undoScheduleSnapshot = (state) => {
  const { redoStack, undoStack } = state.scheduleEditorHistory;

  if (!undoStack.length) return state;

  const current = createSnapshot(state);
  const previous = undoStack[undoStack.length - 1];

  return {
    ...restoreSnapshot(state, previous),
    scheduleEditorHistory: {
      undoStack: undoStack.slice(0, -1),
      redoStack: [...redoStack, current].slice(-HISTORY_LIMIT),
    },
  };
};

export const redoScheduleSnapshot = (state) => {
  const { redoStack, undoStack } = state.scheduleEditorHistory;

  if (!redoStack.length) return state;

  const current = createSnapshot(state);
  const next = redoStack[redoStack.length - 1];

  return {
    ...restoreSnapshot(state, next),
    scheduleEditorHistory: {
      redoStack: redoStack.slice(0, -1),
      undoStack: [...undoStack, current].slice(-HISTORY_LIMIT),
    },
  };
};
